export const sendTagEventFunction = (data: unknown, eventType: string) => {
  window.dataLayer = Array.isArray(window.dataLayer) ? window.dataLayer : [];
  // eslint-disable-next-line @typescript-eslint/ban-types
  const event = { ...(data as object), event: eventType };
  window.dataLayer.push(event);
};
